// Apolo IDE — @ context-menu detector (Cursor "Add agents, context, tools…").
//
// Detects a BARE `@` token the user is typing at the END of the text (end-
// anchored, same discipline as detectFileMentionPrefix / detectSlashPrefix).
// This is the trigger for the ComposerAtMenu. A `@file:`/`@folder:` token (with
// a ':') is NOT a bare `@` — it stays owned by the file typeahead, so the colon
// is deliberately excluded from the query character class. Pure — no I/O.
//
//   "@"        → { query: '', ... }
//   "fix @pl"  → { query: 'pl', ... }
//   "@file:"   → null (the ':' ends the match → file typeahead handles it)
//   "a@b"      → null (must be preceded by start-of-string or whitespace)

const AT_RE = /(^|\s)@([a-z0-9_-]*)$/i;

/**
 * @param {string} text
 * @returns {{ query: string, start: number, end: number } | null}
 *   start = index of the '@'; end = end of text; query = the partial after '@'.
 */
export function detectAtMenuPrefix(text) {
  if (typeof text !== 'string') return null;
  const m = text.match(AT_RE);
  if (!m) return null;
  return {
    query: m[2] || '',
    start: m.index + m[1].length, // skip the (^|\s) → point at the '@'
    end: text.length,
  };
}

// The menu items. Each maps to a REAL Apolo feature (no fake mock entries).
// `action` is interpreted by the composer's onSelect handler. `kw` powers the
// type-to-filter. Kept here (pure data) so the list is unit-testable.
export const AT_MENU_ITEMS = [
  { id: 'plan', label: 'Plan', desc: 'Propor um plano antes de executar', action: 'mode:plan', kw: ['plan', 'plano', 'planejar'] },
  { id: 'multitask', label: 'Multitask', desc: 'Equipe de subagents em paralelo', action: 'mode:team', kw: ['multitask', 'multi', 'equipe', 'team', 'paralelo'] },
  { id: 'ask', label: 'Ask', desc: 'Perguntar antes de ações destrutivas', action: 'mode:ask', kw: ['ask', 'perguntar', 'pergunta'] },
  { id: 'image', label: 'Image', desc: 'Anexar uma imagem', action: 'open:image', kw: ['image', 'imagem', 'img', 'foto', 'print'] },
  { id: 'skills', label: 'Skills', desc: 'Templates e skills', action: 'open:skills', kw: ['skills', 'skill', 'template'] },
  { id: 'files', label: 'Files', desc: 'Arquivos do projeto como contexto', action: 'switch:file', kw: ['files', 'file', 'arquivo', 'arquivos', 'código', 'code'] },
];

/** Filter the items by the typed query (label + keywords substring). */
export function filterAtMenuItems(query) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return AT_MENU_ITEMS;
  return AT_MENU_ITEMS.filter(
    (it) => it.label.toLowerCase().includes(q) || it.kw.some((k) => k.includes(q)),
  );
}
